import {
  select,
  put,
  fork,
  call,
  takeLatest,
  all,
  delay,
} from 'redux-saga/effects';
import app from '../../app';
import {
  loadSkinCareListCompletion,
  loadSkinCareDetailCompletion,
  loadSkinCommentListCompletion,
  loadSkinCommentListAllCompletion,
  addFeedbackCompletion,
  addSkinCareCommentCompletion,
  loadSkinCareShareImgCompletion,
  loadSkinCareCategoryListCompletion,
  updateSkinCareData,
  catchError,
} from '../../actions';

export function* watchLoadSkinCareList() {
  yield takeLatest('LOAD_SKIN_CARE_LIST', function*({categoryId}) {
    const {
      page,
      pageSize,
      noMoreData
    } = yield select(state => state.mall.guide.skinCare.list);
    if(noMoreData) {
      console.log('没有更多内容了')
      return
    }
    const params = {
      start: page,
      size: pageSize,
    }
    if(categoryId) {
      params.categoryId = categoryId
    }
    const options = {
      url: '/sfapi/skinCare/list',
      data: params
    };
    const result = yield call(app.httpFetch, options);
    console.log(result.data, 'page')
    if(result.data && result.data.listData && result.data.listData.length === pageSize) {
      yield put(updateSkinCareData({
        page: page + pageSize
      }))
    }else {
      yield put(updateSkinCareData({
        noMoreData: true
      }))
    }

    yield put(
      loadSkinCareListCompletion(
        result.error,
        result.data || []
      )
    );
  });
}

export function* watchLoadSkinCareCategoryList() {
  yield takeLatest('LOAD_SKIN_CARE_CATEGORY_LIST', function*() {
    
    const options = {
      url: '/sfapi/skinCare/findCategoryAll',
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadSkinCareCategoryListCompletion(
        result.error,
        result.data || []
      )
    );
  });
}

export function* watchLoadSkinCareDetail() {
  yield takeLatest('LOAD_SKIN_CARE_DETAIL', function*({ id }) {
    const options = {
      url: `/sfapi/skinCare/find/${id}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadSkinCareDetailCompletion(
        result.error,
        result.data || {}
      )
    );
  });
}

export function* watchLoadSkinCareShareImg() {
  yield takeLatest('LOAD_SKIN_CARE_SHARE_IMG', function*({ id }) {
    const options = {
      url: `/sfapi/skinCare/${id}/sharePoster`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadSkinCareShareImgCompletion(
        result.error,
        result.data || {}
      )
    );
  });
}

export function* watchLoadSkinCommentList() {
  yield takeLatest('LOAD_SKIN_COMMENT_LIST', function*({ id }) {
    const options = {
      url: `/sfapi/skinCare/comment/${id}/list`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadSkinCommentListCompletion(
        result.error,
        result.data || []
      )
    );
  });
}

export function* watchLoadSkinCommentAllList() {
  yield takeLatest('LOAD_SKIN_COMMENT_ALL_LIST', function*({ id }) {
    const {
      list,
      query: { size },
    } = yield select(state => state.mall.guide.comment.allList);

    const options = {
      url: `/sfapi/skinCare/comment/${id}/list`,
      data: {
        start: list ? list.length : 0,
        size: size,
      },
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadSkinCommentListAllCompletion(
        result.error,
        result.data || {}
      )
    );
  });
}

export function* watchAddFeedback() {
  yield takeLatest('ADD_FEED_BACK', function*({ content }) {
    if (content.length > 200) {
      yield put(catchError('当前您输入的字数已超过200个哦~'));
      yield put(addFeedbackCompletion(true));
      return;
    }
    const options = {
      url: '/sfapi/skinCare/feedback',
      method: 'POST',
      data: {
        content,
      }
    };
    const result = yield call(app.httpFetch, options);
    if (!result.error) {
      yield delay(600);
      app.showTips('none', '发布成功~');
      yield delay(1000);
      yield put(addFeedbackCompletion(undefined));
      return;
    }
    yield put(addFeedbackCompletion(result.error));
  });
}

export function* watchAddSkinCareComment() {
  yield takeLatest('ADD_SKIN_CARE_COMMENT', function*({ id, content, isHide, images }) {
    if (!content) {
      yield put(catchError('请输入内容'));
      return;
    }
    const options = {
      url: '/sfapi/skinCare/comment',
      method: 'POST',
      data: {
        skinCareId: id,
        content,
        isAnony: isHide ? 0 : 1,
        imageVos: images,
      }
    };
    const result = yield call(app.httpFetch, options);
    if (!result.error) {
      yield delay(600);
      app.showTips('none', '发布成功，等待版主确认');
      yield delay(1000);
      yield put(addSkinCareCommentCompletion(undefined));
      return;
    }
    yield put(addSkinCareCommentCompletion(result.error));

  });
}

export default function* guideSaga() {
  yield all([
    fork(watchLoadSkinCareList),
    fork(watchLoadSkinCareDetail),
    fork(watchLoadSkinCareShareImg),
    fork(watchLoadSkinCommentList),
    fork(watchLoadSkinCommentAllList),
    fork(watchAddFeedback),
    fork(watchAddSkinCareComment),
    fork(watchLoadSkinCareCategoryList)
  ]);
}
